

enum BookingZoneRuleType
{
    Occupation,
    Price
}

class BookingZoneSetupViewController extends MUIViewController
{        
    static newInstance() : BookingZoneSetupViewController {
        let vc = new BookingZoneSetupViewController("booking-zone-setup-view");
        vc.initWithResource("layout/bookingzones/BookingZoneSetupView.html");
        return vc;
    }

    private ruleTypeSegmentedControl:MUISegmentedControl = null;
    private saveButton:MUIButton = null;
    private addButton:MUIButton = null;
    private zonesTableView:MUITableView = null;
    private ruleOccupationHeader:MUIView = null;
    private rulePriceHeader:MUIView = null;
    private rulesTableView:MUITableView = null;

    private zonesDataSource:EventProgramZonesSetupDataSource = null;
    private rulesOccupationDataSource:EventProgramOcupationRulesDataSource = null; 
    private rulesPriceDataSource:EventProgramPriceRulesDataSource = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.ruleTypeSegmentedControl = MUIOutlet(this, "rule-type-sc", "MUISegmentedControl");
        if (this.ruleTypeSegmentedControl != null) {
            this.ruleTypeSegmentedControl.setAction(this, function(control, index) {
                let type = parseInt(index);
                this.ruleType = type;
            });
        }

        this.saveButton = MUIOutlet(this, "save-btn", "MUIButton");
        if (this.saveButton != null) this.saveButton.setAction(this, function(){
            DBHelper.saveMainContext();
        });

        this.addButton = MUIOutlet(this, "add-btn", "MUIButton");
        if (this.addButton != null) this.addButton.setAction(this, function(){
            this.addRule();
        });

        this.zonesTableView = MUIOutlet(this, "zones-table-view", "MUITableView");
        this.zonesDataSource = new EventProgramZonesSetupDataSource();
        this.zonesDataSource.initWithTableView(this.zonesTableView, this);
        this.zonesTableView.dataSource = this.zonesDataSource;
        this.zonesTableView.delegate = this.zonesDataSource;
        
        this.zonesTableView.reloadData();

        this.ruleOccupationHeader = MUIOutlet(this, "rule-occupation-header", "MUIView");
        this.rulePriceHeader = MUIOutlet(this, "rule-price-header", "MUIView");
        this.rulePriceHeader.hidden = true;

        this.rulesTableView = MUIOutlet(this, "rules-table-view", "MUITableView");
        this.rulesOccupationDataSource = new EventProgramOcupationRulesDataSource();
        this.rulesOccupationDataSource.initWithTableView(this.rulesTableView, this);
        this.rulesTableView.dataSource = this.rulesOccupationDataSource;        

        this.rulesPriceDataSource = new EventProgramPriceRulesDataSource();
        this.rulesPriceDataSource.initWithTableView(this.rulesTableView, this);

        this.rulesTableView.delegate = this;
    }

    viewWillAppear(animated?){
        super.viewWillAppear(animated);
        this.updateUI();
    }
    
    private selectedEventID:string = null;
    set event(event:BookingEvent){
        this.selectedEventID = event.identifier;
        this.updateUI();       
    }

    private selectedEventProgramID:string = null;
    set eventProgram(eventProgram:EventProgram){
        this.selectedEventProgramID = eventProgram.identifier;
        this.updateUI();
    }

    private updateUI(){
        if (this.viewIsLoaded == false || this.selectedZone == null) return;

        if (this.selectedRuleType == BookingZoneRuleType.Occupation) this.rulesOccupationDataSource.setItems(this.selectedZone, this.selectedEventID, this.selectedEventProgramID);        
        else if (this.selectedRuleType == BookingZoneRuleType.Price) this.rulesPriceDataSource.setItems(this.selectedZone, this.selectedEventID, this.selectedEventProgramID);        
    }


    editingStyleForRowAtIndexPath(tableView:MUITableView, indexPath:MIOIndexPath) {        
        return MUITableViewCellEditingStyle.Delete;
    }

    commitEditingStyleForRowAtIndexPath(tableView, editingStyle:MUITableViewCellEditingStyle, indexPath:MIOIndexPath) {
        let item = tableView.dataSource.fetchedResultsController.objectAtIndexPath(indexPath);

        if (editingStyle == MUITableViewCellEditingStyle.Delete) {
            DBHelper.deleteObjectFromMainContext(item, true);
        }
    }

    private selectedRuleType = BookingZoneRuleType.Occupation;
    addRule(){
        if (this.selectedZone == null) return;

        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        
        if (this.selectedRuleType == BookingZoneRuleType.Occupation){
            let rule = MIOEntityDescription.insertNewObjectForEntityForName("BookingZoneOcupationRule", ad.managedObjectContext) as BookingZoneOcupationRule;
            rule.partyID = this.selectedEventProgramID;
            rule.eventID = this.selectedEventID;
            rule.zone = this.selectedZone;
        }
        else if (this.selectedRuleType == BookingZoneRuleType.Price){
            let rule = MIOEntityDescription.insertNewObjectForEntityForName("BookingPriceRule", ad.managedObjectContext) as BookingZoneOcupationRule;
            rule.partyID = this.selectedEventProgramID;
            rule.eventID = this.selectedEventID;
            rule.zone = this.selectedZone;
        }

        ad.managedObjectContext.save();
    }

    set ruleType(type:BookingZoneRuleType){
        this.selectedRuleType = type;
        switch(type){
            case BookingZoneRuleType.Occupation:
                this.ruleOccupationHeader.hidden = false;
                this.rulePriceHeader.hidden = true;
                this.rulesTableView.dataSource = this.rulesOccupationDataSource;
                this.updateUI();
                break;                 

            case BookingZoneRuleType.Price:
                this.rulePriceHeader.hidden = false;                
                this.ruleOccupationHeader.hidden = true;
                this.rulesTableView.dataSource = this.rulesPriceDataSource;
                this.updateUI();
                break;
        }
    }

    private selectedZone:BookingZone = null;   
    didSelectZone(zone:BookingZone){
        this.selectedZone = zone;  
        this.updateUI();
    }

}